import React from 'react';
import { layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';
import { Column, GridRow } from '@prisjakt/ui/list/variants';

import * as S from './styles';

type Props = {
  productCount?: number;
  hasFiltered?: boolean;
  onClick: () => void;
  onClear?: () => void;
  canClear?: boolean;
};

const ApplyFilterButton = ({
  productCount = 0,
  hasFiltered = true,
  onClick,
  onClear,
  canClear = true,
}: Props) => (
  <S.ActionBar>
    <Column gap={layout.spacing.rem.xSmall}>
      <S.ProductCount>
        <T domain="filter" n={productCount}>
          result.n-products
        </T>
      </S.ProductCount>
      <GridRow gap={layout.spacing.rem.xSmall}>
        {onClear && (
          <Button
            color="tertiary"
            variant="outlined"
            onClick={onClear}
            disabled={!canClear}
          >
            <T domain="filter">button.clear-filter</T>
          </Button>
        )}
        <Button color="primary" onClick={onClick} disabled={!hasFiltered}>
          <T domain="filter">button.apply-filter</T>
        </Button>
      </GridRow>
    </Column>
  </S.ActionBar>
);

export default ApplyFilterButton;
